// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__ms--y","Header--short":"Header_Header--short__s0qZH","Header--NavbarOnly":"Header_Header--NavbarOnly__CM03U"};